import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { CheckmarkIcon } from '@components/IconComponents/CheckmarkIcon';
import { checkboxButtonStyles as classes } from '@components/styleObjects/CheckboxInputButtonStyles';
import { Text } from '@web-for-marketing/react-ui';

interface CheckboxInputButtonProps {
    label: string;
    name: string;
    checked?: boolean;
    hidden?: boolean;
    onChange?: (checked: boolean) => void;
}

export const CheckboxInputButton = ({
    label,
    name,
    checked = false,
    onChange,
    hidden = false,
}: CheckboxInputButtonProps): JSX.Element => {
    const [isChecked, setIsChecked] = useState<boolean>(checked);

    function changeHandler(): void {
        setIsChecked((prevState) => !prevState);
        if (onChange) {
            onChange(!isChecked);
        }
    }

    return (
        <Grid css={classes.container}>
            <input
                type='checkbox'
                checked={isChecked}
                css={classes.hiddenCheckbox}
                data-testid={`${name || label.trim()}-checkbox`}
                onChange={changeHandler}
                tabIndex={hidden ? -1 : 0}
                aria-disabled={hidden}
                aria-label={name}
            />
            <Grid
                container
                direction='row'
                wrap='nowrap'
                alignItems='center'
                css={classes.contentContainer}
                onClick={changeHandler}
            >
                <Grid css={classes.checkbox}>{isChecked ? <CheckmarkIcon /> : null}</Grid>
                <Text id={name} css={classes.label} color='tertiary'>
                    {label}
                </Text>
            </Grid>
        </Grid>
    );
};
